import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import Maps from "../../components/pages/Contacts/Maps/Maps";

const ContactsPage: React.FC = () => {
  return (
    <Layout>
      <Maps />
      <Feedback />
    </Layout>
  );
};

export default ContactsPage;
